var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { components } from 'react-select';
import AsyncSelect from 'react-select/async';
import { ThemeConsumer, ThemeContext } from 'styled-components';
import { customStyles } from './ImgSelect';
function ImgAsyncSelect(p) {
    var changeSingleValue = p.changeSingleValue, changeMultiValue = p.changeMultiValue, changeOption = p.changeOption, onChange = p.onChange, rest = __rest(p, ["changeSingleValue", "changeMultiValue", "changeOption", "onChange"]);
    var theme = React.useContext(ThemeContext);
    var styles = React.useMemo(function () {
        return customStyles(theme, false);
    }, [theme]);
    var MultiValueLabel = React.useMemo(function () { return function (p) {
        return React.createElement(components.MultiValueLabel, __assign({}, p), changeMultiValue(p.data));
    }; }, [changeMultiValue]);
    var SingleValue = React.useMemo(function () { return function (p) {
        return React.createElement(components.SingleValue, __assign({}, p), changeSingleValue(p.data));
    }; }, [changeSingleValue]);
    var OptionR = React.useMemo(function () { return function (p) {
        return React.createElement(components.Option, __assign({}, p), changeOption(p.data));
    }; }, [changeOption]);
    var chg = React.useMemo(function () { return function (val, actionMeta) {
        if (onChange) {
            if (val === null)
                onChange(null, actionMeta);
            else
                onChange(val, actionMeta);
        }
    }; }, [onChange]);
    return (React.createElement(ThemeConsumer, null, function (theme) {
        return React.createElement(AsyncSelect, __assign({ styles: styles, components: {
                Option: changeOption ? OptionR : undefined,
                SingleValue: changeSingleValue ? SingleValue : undefined,
                MultiValueLabel: changeMultiValue ? MultiValueLabel : undefined,
            }, onChange: chg }, rest));
    }));
}
;
export default ImgAsyncSelect;
//# sourceMappingURL=ImgAsyncSelect.js.map